module.exports = __webpack_public_path__ + "img/croc.858801e1.svg";